import GomokuGame from "@/components/game/GomokuGame.vue";

const games = [
    {
        path: '/gomokugame',
        name: 'GomokuGame',
        component: GomokuGame
    },
]
export default games;
